import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

export default function CertificationsModal({ open, onClose }) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ backgroundColor: '#50A579', color: 'white', textAlign: 'center' }}>
        {t('certifications.dialogTitle')}
      </DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#e8f5e9', minWidth: 320, py: 3 }}>
        <Typography sx={{ mb: 3, color: '#333', fontWeight: 500, textAlign: 'center', mt: 3 }}>
          {t('certifications.selectPrompt') || '¿Sobre qué certificación estás interesad@?'}
        </Typography>
        <Button
          variant="contained"
          sx={{
            backgroundColor: '#50A579',
            color: 'white',
            width: '80%',
            mb: 2,
            fontWeight: 600,
            fontSize: '1.1rem',
            boxShadow: 2,
            '&:hover': { backgroundColor: '#388e5c' }
          }}
          onClick={() => {
            onClose();
            window.open('https://shorturl.at/5oAXR', '_blank', 'noopener');
          }}
        >
          Cambridge
        </Button>
        <Button
          variant="contained"
          sx={{
            backgroundColor: '#50A579',
            color: 'white',
            width: '80%',
            fontWeight: 600,
            fontSize: '1.1rem',
            boxShadow: 2,
            '&:hover': { backgroundColor: '#388e5c' }
          }}
          onClick={() => {
            onClose();
            window.open('https://www.vilatraining.cat/oxford-test-of-english', '_blank', 'noopener');
          }}
        >
          Oxford
        </Button>
      </DialogContent>
      <DialogActions sx={{ backgroundColor: '#e8f5e9' }}>
        <Button onClick={onClose} sx={{ color: '#50A579', fontWeight: 600 }}>{t('certifications.cancel')}</Button>
      </DialogActions>
    </Dialog>
  );
}
